// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper[data-v-226e8211] {
  --swiper-pagination-bullet-width: 36px;
  --swiper-pagination-bullet-height: 4px;
  --swiper-pagination-bullet-border-radius: 9999px 9999px 0 0;
  --swiper-pagination-color: rgb(var(--color-primary));
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
